"use client";
import * as React from "react";
const SvgEditOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m9.83 5.35.82.82-8.05 8.05h-.82v-.82zM13.03 0a1 1 0 0 0-.62.26l-1.63 1.62 3.33 3.34 1.63-1.63a.9.9 0 0 0 0-1.25L13.66.26a1 1 0 0 0-.63-.26m-3.2 2.84L0 12.66V16h3.33l9.83-9.83z" }));
export {
  SvgEditOutlined as default
};
